<template>
    <div class="system-info-container">
        <el-card class="system-card" shadow="hover">
            <div slot="header" class="card-header">
                <span class="header-title">
                    <i class="el-icon-setting"></i>
                    系统配置信息
                </span>
                <el-tag v-if="form.system_status == '1'" type="success" size="medium" effect="dark">
                    <i class="el-icon-check"></i> 系统运行中
                </el-tag>
                <el-tag v-else type="danger" size="medium" effect="dark">
                    <i class="el-icon-close"></i> 系统已停用
                </el-tag>
            </div>

            <el-form class="SystemForm" ref="form" :model="form" label-width="120px">
                <!-- 基础信息区域 -->
                <div class="form-section">
                    <div class="section-title">
                        <i class="el-icon-info"></i>
                        基础信息
                    </div>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="用户数：">
                                <el-input 
                                    v-model="form.user_sum" 
                                    placeholder="请输入用户数"
                                    prefix-icon="el-icon-user"
                                    :disabled="perData.allow_edit != 1"
                                >
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="注册日期：">
                                <div class="date-picker-wrapper">
                                    <el-date-picker 
                                        style="width: 100%"
                                        type="date" 
                                        value-format="yyyy-MM-dd" 
                                        v-model="form.sign_date" 
                                        placeholder="选择注册日期"
                                        :disabled="perData.allow_edit != 1"
                                    > 
                                    </el-date-picker>
                                    <el-button
                                        v-if="perData.allow_edit == 1"
                                        type="success"
                                        size="small"
                                        icon="el-icon-date"
                                        @click="setTodayDate()"
                                        class="today-btn"
                                        title="设置为今天日期"
                                    >
                                        今天
                                    </el-button>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="到期日期：">
                                <div class="date-picker-wrapper">
                                    <el-date-picker 
                                        style="width: 100%"
                                        type="date" 
                                        value-format="yyyy-MM-dd" 
                                        v-model="form.end_date" 
                                        placeholder="选择到期日期"
                                        :disabled="perData.allow_edit != 1"
                                    > 
                                    </el-date-picker>
                                    <el-button
                                        v-if="perData.allow_edit == 1"
                                        type="primary"
                                        size="small"
                                        icon="el-icon-setting"
                                        @click="showDateQuickSetDialog('end')"
                                        class="quick-set-btn"
                                        title="快速设置日期"
                                    >
                                        快捷设置
                                    </el-button>
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="唯一登录：">
                                <div class="switch-wrapper">
                                    <el-switch 
                                        v-model="form.only_login" 
                                        :active-value="1" 
                                        :inactive-value="0"
                                        :disabled="perData.allow_edit != 1"
                                    > 
                                    </el-switch>
                                    <el-tag 
                                        :type="form.only_login == '1' ? 'success' : 'info'" 
                                        size="small"
                                        effect="plain"
                                        class="status-tag"
                                    >
                                        {{ form.only_login == 1 ? '已开启' : '已关闭' }}
                                    </el-tag>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>

                <!-- 功能模块区域 -->
                <div class="form-section">
                    <div class="section-title">
                        <i class="el-icon-menu"></i>
                        功能模块配置
                    </div>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="多门店：">
                                <div class="switch-wrapper">
                                    <el-switch
                                        v-model="form.isstores"
                                        :active-value="1"
                                        :inactive-value="0"
                                        :disabled="perData.allow_edit != 1"
                                    >
                                    </el-switch>
                                    <el-tag
                                        :type="form.isstores == '1' ? 'success' : 'info'"
                                        size="small"
                                        effect="plain"
                                        class="status-tag"
                                    >
                                        {{ form.isstores == 1 ? '已启用' : '已停用' }}
                                    </el-tag>
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="会员管理：">
                                <div class="switch-wrapper">
                                    <el-switch
                                        v-model="form.isMember"
                                        :active-value="1"
                                        :inactive-value="0"
                                        :disabled="perData.allow_edit != 1"
                                    >
                                    </el-switch>
                                    <el-tag
                                        :type="form.isMember == '1' ? 'success' : 'info'"
                                        size="small"
                                        effect="plain"
                                        class="status-tag"
                                    >
                                        {{ form.isMember == 1 ? '已启用' : '已停用' }}
                                    </el-tag>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="批量模块：">
                                <div class="switch-wrapper">
                                    <el-switch
                                        v-model="form.isbatchmodule"
                                        :active-value="1"
                                        :inactive-value="0"
                                        :disabled="perData.allow_edit != 1"
                                    >
                                    </el-switch>
                                    <el-tag
                                        :type="form.isbatchmodule == '1' ? 'success' : 'info'"
                                        size="small"
                                        effect="plain"
                                        class="status-tag"
                                    >
                                        {{ form.isbatchmodule == 1 ? '已启用' : '已停用' }}
                                    </el-tag>
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="账款管理：">
                                <div class="switch-wrapper">
                                    <el-switch 
                                        v-model="form.isaccouns" 
                                        :active-value="1" 
                                        :inactive-value="0"
                                        :disabled="perData.allow_edit != 1"
                                    > 
                                    </el-switch>
                                    <el-tag 
                                        :type="form.isaccouns == '1' ? 'success' : 'info'" 
                                        size="small"
                                        effect="plain"
                                        class="status-tag"
                                    >
                                        {{ form.isaccouns == 1 ? '已启用' : '已停用' }}
                                    </el-tag>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="配货功能：">
                                <div class="switch-wrapper">
                                    <el-switch
                                        v-model="form.isdistsales"
                                        :active-value="1"
                                        :inactive-value="0"
                                        :disabled="perData.allow_edit != 1"
                                    >
                                    </el-switch>
                                    <el-tag
                                        :type="form.isdistsales == '1' ? 'success' : 'info'"
                                        size="small"
                                        effect="plain"
                                        class="status-tag"
                                    >
                                        {{ form.isdistsales == 1 ? '已启用' : '已停用' }}
                                    </el-tag>
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="利息模块：">
                                <div class="switch-wrapper">
                                    <el-switch
                                        v-model="form.isinterest"
                                        :active-value="1"
                                        :inactive-value="0"
                                        :disabled="perData.allow_edit != 1"
                                    >
                                    </el-switch>
                                    <el-tag
                                        :type="form.isinterest == '1' ? 'success' : 'info'"
                                        size="small"
                                        effect="plain"
                                        class="status-tag"
                                    >
                                        {{ form.isinterest == 1 ? '已启用' : '已停用' }}
                                    </el-tag>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="委外加工：">
                                <div class="switch-wrapper">
                                    <el-switch 
                                        v-model="form.isoutsourcprocess" 
                                        :active-value="1" 
                                        :inactive-value="0"
                                        :disabled="perData.allow_edit != 1"
                                    > 
                                    </el-switch>
                                    <el-tag 
                                        :type="form.isoutsourcprocess == '1' ? 'success' : 'info'" 
                                        size="small"
                                        effect="plain"
                                        class="status-tag"
                                    >
                                        {{ form.isoutsourcprocess == 1 ? '已启用' : '已停用' }}
                                    </el-tag>
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="粗料管理：">
                                <div class="switch-wrapper">
                                    <el-switch
                                        v-model="form.isCoarseMetaManage"
                                        :active-value="1"
                                        :inactive-value="0"
                                        :disabled="perData.allow_edit != 1"
                                    >
                                    </el-switch>
                                    <el-tag
                                        :type="form.isCoarseMetaManage == '1' ? 'success' : 'info'"
                                        size="small"
                                        effect="plain"
                                        class="status-tag"
                                    >
                                        {{ form.isCoarseMetaManage == 1 ? '已启用' : '已停用' }}
                                    </el-tag>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="金料定价：">
                                <div class="switch-wrapper">
                                    <el-switch 
                                        v-model="form.ismetalpricing" 
                                        :active-value="1" 
                                        :inactive-value="0"
                                        :disabled="perData.allow_edit != 1"
                                    > 
                                    </el-switch>
                                    <el-tag 
                                        :type="form.ismetalpricing == '1' ? 'success' : 'info'" 
                                        size="small"
                                        effect="plain"
                                        class="status-tag"
                                    >
                                        {{ form.ismetalpricing == 1 ? '已启用' : '已停用' }}
                                    </el-tag>
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="金料提纯：">
                                <div class="switch-wrapper">
                                    <el-switch 
                                        v-model="form.ismetalpurify" 
                                        :active-value="1" 
                                        :inactive-value="0"
                                        :disabled="perData.allow_edit != 1"
                                    > 
                                    </el-switch>
                                    <el-tag 
                                        :type="form.ismetalpurify == '1' ? 'success' : 'info'" 
                                        size="small"
                                        effect="plain"
                                        class="status-tag"
                                    >
                                        {{ form.ismetalpurify == 1 ? '已启用' : '已停用' }}
                                    </el-tag>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="一件一码：">
                                <div class="switch-wrapper">
                                    <el-switch 
                                        v-model="form.isbarcode" 
                                        :active-value="1" 
                                        :inactive-value="0"
                                        :disabled="perData.allow_edit != 1"
                                    > 
                                    </el-switch>
                                    <el-tag 
                                        :type="form.isbarcode == '1' ? 'success' : 'info'" 
                                        size="small"
                                        effect="plain"
                                        class="status-tag"
                                    >
                                        {{ form.isbarcode == 1 ? '已启用' : '已停用' }}
                                    </el-tag>
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="条码组装：">
                                <div class="switch-wrapper">
                                    <el-switch
                                        v-model="form.isBarcodesAssembly"
                                        :active-value="1"
                                        :inactive-value="0"
                                        :disabled="perData.allow_edit != 1"
                                    >
                                    </el-switch>
                                    <el-tag
                                        :type="form.isBarcodesAssembly == '1' ? 'success' : 'info'"
                                        size="small"
                                        effect="plain"
                                        class="status-tag"
                                    >
                                        {{ form.isBarcodesAssembly == 1 ? '已启用' : '已停用' }}
                                    </el-tag>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="金包银：">
                                <div class="switch-wrapper">
                                    <el-switch
                                        v-model="form.isgoldsilver"
                                        :active-value="1"
                                        :inactive-value="0"
                                        :disabled="perData.allow_edit != 1"
                                    >
                                    </el-switch>
                                    <el-tag
                                        :type="form.isgoldsilver == '1' ? 'success' : 'info'"
                                        size="small"
                                        effect="plain"
                                        class="status-tag"
                                    >
                                        {{ form.isgoldsilver == 1 ? '已启用' : '已停用' }}
                                    </el-tag>
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="国际贸易：">
                                <div class="switch-wrapper">
                                    <el-switch 
                                        v-model="form.isinternationaltrade" 
                                        :active-value="1" 
                                        :inactive-value="0"
                                        :disabled="perData.allow_edit != 1"
                                    > 
                                    </el-switch>
                                    <el-tag 
                                        :type="form.isinternationaltrade == '1' ? 'success' : 'info'" 
                                        size="small"
                                        effect="plain"
                                        class="status-tag"
                                    >
                                        {{ form.isinternationaltrade == 1 ? '已启用' : '已停用' }}
                                    </el-tag>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>

                <!-- 保存按钮区域 -->
                <div class="save-section" v-if="perData.allow_edit == 1">
                    <el-button
                        v-preventReClick
                        type="primary"
                        size="medium"
                        icon="el-icon-check"
                        @click="saveIt()"
                        class="save-btn"
                    >
                        保存配置
                    </el-button>
                    <el-button
                        size="medium"
                        icon="el-icon-refresh"
                        @click="geData()"
                        class="reset-btn"
                    >
                        {{ $t('common.reset') }}
                    </el-button>
                </div>
            </el-form>
        </el-card>

        <!-- 日期快捷设置弹窗 -->
        <el-dialog
            :title="dialogType === 'sign' ? '注册日期快捷设置' : '到期日期快捷设置'"
            :visible.sync="dateDialogVisible"
            width="500px"
            :close-on-click-modal="false"
        >
            <div class="quick-set-dialog">
                <!-- 注册日期快捷选项 -->
                <div v-if="dialogType === 'sign'" class="dialog-section">
                    <el-button
                        type="success"
                        icon="el-icon-date"
                        @click="setTodayDate()"
                        class="dialog-btn"
                    >
                        设为今天
                    </el-button>
                </div>

                <!-- 到期日期快捷选项 -->
                <div v-if="dialogType === 'end'" class="dialog-section">
                    <div class="section-title">租用设置（从注册日期）</div>
                    <div class="button-grid">
                        <el-button
                            type="primary"
                            icon="el-icon-time"
                            @click="setRentDate(1)"
                            class="dialog-btn"
                        >
                            租用一年
                        </el-button>
                        <el-button
                            type="primary"
                            icon="el-icon-time"
                            @click="setRentDate(2)"
                            class="dialog-btn"
                        >
                            租用两年
                        </el-button>
                        <el-button
                            type="primary"
                            icon="el-icon-time"
                            @click="setRentDate(3)"
                            class="dialog-btn"
                        >
                            租用三年
                        </el-button>
                        <el-button
                            type="warning"
                            icon="el-icon-star-on"
                            @click="setBuyoutDate()"
                            class="dialog-btn"
                        >
                            买断（2099-12-31）
                        </el-button>
                    </div>
                </div>

                <div class="dialog-section" v-if="dialogType === 'end'">
                    <div class="section-title">续期设置（从当前到期日期）</div>
                    <div class="button-grid">
                        <el-button
                            type="success"
                            icon="el-icon-plus"
                            @click="renewByDays(7)"
                            class="dialog-btn"
                        >
                            续期一周
                        </el-button>
                        <el-button
                            type="success"
                            icon="el-icon-plus"
                            @click="renewByDays(14)"
                            class="dialog-btn"
                        >
                            续期二周
                        </el-button>
                        <el-button
                            type="success"
                            icon="el-icon-plus"
                            @click="renewByYears(1)"
                            class="dialog-btn"
                        >
                            续期一年
                        </el-button>
                        <el-button
                            type="success"
                            icon="el-icon-plus"
                            @click="renewByYears(2)"
                            class="dialog-btn"
                        >
                            续期两年
                        </el-button>
                    </div>

                    <div class="extend-input-wrapper">
                        <span class="input-label">自定义天数:</span>
                        <el-input-number
                            v-model="extendDays"
                            :min="1"
                            :max="9999"
                            :step="1"
                            placeholder="输入天数"
                            controls-position="right"
                            class="days-input"
                        ></el-input-number>
                        <span class="unit-text">天</span>
                        <el-button
                            type="success"
                            icon="el-icon-check"
                            @click="extendByDays()"
                            class="extend-btn"
                        >
                            确认续期
                        </el-button>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dateDialogVisible = false">{{ $t('common.close') }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { apiSystem, apiSystemSave, apiSystemPull, apiCurrentPermisson } from '@/request/api';
export default {
    data() {
        return {
            allArr: '',
            form: {},
            pull_currency: [],
            pull_server: [],
            perData: '',
            ms_username: localStorage.getItem('ms_username') || '',
            extendDays: '', // 延期天数输入框
            dateDialogVisible: false, // 日期快捷设置弹窗
            dialogType: 'sign' // 弹窗类型：sign-注册日期，end-到期日期
        };
    },
    created() {
        this.geData();
        this.getStoneData();
        this.getPermission();
    },
    methods: {
        // 获取页面信息-----------------------------------------
        geData() {
            apiSystem({}).then((res) => {
                if (res.code == 2000) {
                    this.form = res.data;
                } else {
                    if (res.data.info == '无数据请先添加' || res.data.info == '没有这条数据') {
                        this.form = {};
                    }
                    this.$message.error(res.data.info);
                }
            });
        },
        // 获取下拉框信息---------------------------------------
        getStoneData() {
            apiSystemPull({}).then((res) => {
                if (res.code == 2000) {
                    this.allArr = res.data;
                    this.pull_currency = res.data.currency;
                    this.pull_server = res.data.server;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '51'
            }).then((res) => {
                if (res.code == 2000) {
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 自定义下拉框筛选
        searchCurr(val) {
            this.form.currency_no = val;
            if (val) {
                var len = this.allArr.currency;
                var arr = [];
                for (var i = 0; i < len.length; i++) {
                    if (len[i].kind_no.toLowerCase().indexOf(val.toLowerCase()) >= 0 || len[i].kind_name.indexOf(val) >= 0) {
                        arr.push(len[i]);
                    }
                }
                this.pull_currency = arr;
            } else {
                this.pull_currency = this.allArr.currency;
            }
        },
        searchServer(val) {
            this.form.server = val;
            if (val) {
                var len = this.allArr.server;
                var arr = [];
                for (var i = 0; i < len.length; i++) {
                    if (len[i].kind_no.toLowerCase().indexOf(val.toLowerCase()) >= 0 || len[i].kind_name.indexOf(val) >= 0) {
                        arr.push(len[i]);
                    }
                }
                this.pull_server = arr;
            } else {
                this.pull_server = this.allArr.server;
            }
        },
        refreshs() {
            this.$forceUpdate();
        },
        //保存
        saveIt() {
            let data = this.form;
            apiSystemSave(data).then((res) => {
                if (res.code == 2000) {
                    this.$message.success('修改成功');
                    this.form = res.data;
                    localStorage.setItem('systemSet', JSON.stringify(res.data));
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 显示日期快捷设置弹窗
        showDateQuickSetDialog(type) {
            this.dialogType = type;
            this.extendDays = '';
            this.dateDialogVisible = true;
        },
        // 设置买断日期（最大日期）
        setBuyoutDate() {
            this.$confirm('确定要将系统设置为买断模式吗？到期日期将设置为 2099-12-31', '提示', {
                confirmButtonText: this.$t('common.confirm') ,
                cancelButtonText: this.$t('common.cancel') ,
                type: 'warning'
            }).then(() => {
                this.form.end_date = '2099-12-31';
                this.$message.success('已设置为买断模式，请点击保存配置使更改生效');
                this.dateDialogVisible = false;
            }).catch(() => {
                // 用户取消操作
            });
        },
        // 设置注册日期为今天
        setTodayDate() {
            const today = new Date();
            const year = today.getFullYear();
            const month = String(today.getMonth() + 1).padStart(2, '0');
            const day = String(today.getDate()).padStart(2, '0');
            this.form.sign_date = `${year}-${month}-${day}`;
            this.$message.success('注册日期已设置为今天，请点击保存配置使更改生效');
        },
        // 设置租用日期（从注册日期开始计算）
        setRentDate(years) {
            if (!this.form.sign_date) {
                this.$message.warning('请先设置注册日期');
                return;
            }
            
            const signDate = new Date(this.form.sign_date);
            const targetDate = new Date(signDate);
            targetDate.setFullYear(targetDate.getFullYear() + years);
            
            const year = targetDate.getFullYear();
            const month = String(targetDate.getMonth() + 1).padStart(2, '0');
            const day = String(targetDate.getDate()).padStart(2, '0');
            this.form.end_date = `${year}-${month}-${day}`;
            
            this.$message.success(`到期日期已设置为 ${this.form.end_date}（注册日期后${years}年），请点击保存配置使更改生效`);
            this.dateDialogVisible = false;
        },
        // 按天续期（通用方法）
        renewByDays(days) {
            if (!this.form.end_date) {
                this.$message.warning('请先设置到期日期');
                return;
            }
            
            const currentDate = new Date(this.form.end_date);
            const targetDate = new Date(currentDate);
            targetDate.setDate(targetDate.getDate() + days);
            
            const year = targetDate.getFullYear();
            const month = String(targetDate.getMonth() + 1).padStart(2, '0');
            const day = String(targetDate.getDate()).padStart(2, '0');
            this.form.end_date = `${year}-${month}-${day}`;
            
            let message = '';
            if (days === 7) {
                message = `到期日期已续期一周，新日期为 ${this.form.end_date}，请点击保存配置使更改生效`;
            } else if (days === 14) {
                message = `到期日期已续期二周，新日期为 ${this.form.end_date}，请点击保存配置使更改生效`;
            } else {
                message = `到期日期已续期${days}天，新日期为 ${this.form.end_date}，请点击保存配置使更改生效`;
            }
            
            this.$message.success(message);
            this.dateDialogVisible = false;
        },
        // 按年续期（从当前到期日期开始计算）
        renewByYears(years) {
            if (!this.form.end_date) {
                this.$message.warning('请先设置到期日期');
                return;
            }
            
            const currentDate = new Date(this.form.end_date);
            const targetDate = new Date(currentDate);
            targetDate.setFullYear(targetDate.getFullYear() + years);
            
            const year = targetDate.getFullYear();
            const month = String(targetDate.getMonth() + 1).padStart(2, '0');
            const day = String(targetDate.getDate()).padStart(2, '0');
            this.form.end_date = `${year}-${month}-${day}`;
            
            this.$message.success(`到期日期已续期${years}年，新日期为 ${this.form.end_date}，请点击保存配置使更改生效`);
            this.dateDialogVisible = false;
        },
        // 按天数续期
        extendByDays() {
            if (!this.extendDays || this.extendDays <= 0) {
                this.$message.warning('请输入有效的延期天数');
                return;
            }
            
            if (!this.form.end_date) {
                this.$message.warning('请先设置到期日期');
                return;
            }
            
            const currentDate = new Date(this.form.end_date);
            const extendedDate = new Date(currentDate);
            extendedDate.setDate(extendedDate.getDate() + parseInt(this.extendDays));
            
            const year = extendedDate.getFullYear();
            const month = String(extendedDate.getMonth() + 1).padStart(2, '0');
            const day = String(extendedDate.getDate()).padStart(2, '0');
            this.form.end_date = `${year}-${month}-${day}`;
            
            this.$message.success(`到期日期已续期 ${this.extendDays} 天，新日期为 ${this.form.end_date}，请点击保存配置使更改生效`);
            this.extendDays = ''; // 清空输入
        }
    }
};
</script>

<style scoped lang="scss">
.system-info-container {
    padding: 20px;
    background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%);
    min-height: calc(100vh - 100px);
}

.system-card {
    max-width: 1200px;
    margin: 0 auto;
    border-radius: 12px;
    overflow: hidden;
    transition: all 0.3s ease;

    &:hover {
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
        transform: translateY(-2px);
    }

    /deep/ .el-card__header {
        background: linear-gradient(135deg, #0084ff 0%, #0066cc 100%);
        padding: 20px 24px;
        border-bottom: none;
    }

    /deep/ .el-card__body {
        padding: 30px;
        background: #ffffff;
    }
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.header-title {
    color: #ffffff;
    font-size: 18px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 8px;

    i {
        font-size: 20px;
    }
}

.SystemForm {
    background: transparent;
    padding: 0;
}

.form-section {
    margin-bottom: 30px;
    padding: 20px;
    background: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #e9ecef;
    transition: all 0.3s ease;

    &:hover {
        background: #ffffff;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
        border-color: #d0d7de;
    }

    &:last-child {
        margin-bottom: 0;
    }
}

.section-title {
    font-size: 16px;
    font-weight: 600;
    color: #2c3e50;
    margin-bottom: 20px;
    padding-bottom: 12px;
    border-bottom: 2px solid #0084ff;
    display: flex;
    align-items: center;
    gap: 8px;

    i {
        color: #0084ff;
        font-size: 18px;
    }
}

/deep/ .el-form-item {
    margin-bottom: 20px;
}

/deep/ .el-form-item__label {
    font-weight: 500;
    color: #495057;
    font-size: 14px;
}

/deep/ .el-input__inner {
    border-radius: 6px;
    transition: all 0.3s ease;
    border: 1px solid #dcdfe6;

    &:focus {
        border-color: #0084ff;
        box-shadow: 0 0 0 2px rgba(0, 132, 255, 0.1);
    }
}

/deep/ .el-date-editor.el-input,
/deep/ .el-date-editor.el-input__inner {
    width: 100%;
}

.switch-wrapper {
    display: flex;
    align-items: center;
    gap: 12px;
}

.status-tag {
    margin-left: 0;
    font-weight: 500;
    min-width: 60px;
    text-align: center;
}

.date-picker-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;

    /deep/ .el-date-editor {
        flex: 1;
    }
}

.buyout-btn {
    white-space: nowrap;
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(230, 162, 60, 0.3);
    }
}

.today-btn {
    white-space: nowrap;
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(103, 194, 58, 0.3);
    }
}

.today-btn {
    white-space: nowrap;
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(103, 194, 58, 0.3);
    }
}

.quick-set-btn {
    white-space: nowrap;
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(0, 132, 255, 0.3);
    }
}

// 弹窗样式
/deep/ .el-dialog__header {
    background: linear-gradient(135deg, #0084ff 0%, #0066cc 100%);
    padding: 20px 24px;
    margin: 0;
    
    .el-dialog__title {
        color: #ffffff;
        font-size: 18px;
        font-weight: 600;
    }
    
    .el-dialog__headerbtn {
        top: 20px;
        
        .el-dialog__close {
            color: #ffffff;
            font-size: 20px;
            font-weight: bold;
            
            &:hover {
                color: #f0f7ff;
            }
        }
    }
}

/deep/ .el-dialog__body {
    padding: 24px;
    background: #f8f9fa;
}

/deep/ .el-dialog__footer {
    padding: 16px 24px;
    border-top: 1px solid #e9ecef;
    background: #ffffff;
}

.quick-set-dialog {
    padding: 0;
}

.dialog-section {
    margin-bottom: 20px;
    background: #ffffff;
    border-radius: 10px;
    padding: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    transition: all 0.3s ease;
    
    &:hover {
        box-shadow: 0 4px 12px rgba(0, 132, 255, 0.12);
        transform: translateY(-2px);
    }

    &:last-child {
        margin-bottom: 0;
    }

    .section-title {
        font-size: 15px;
        font-weight: 600;
        color: #2c3e50;
        margin-bottom: 14px;
        padding-bottom: 10px;
        border-bottom: 2px solid #f0f0f0;
        display: flex;
        align-items: center;
        gap: 8px;
        
        &::before {
            content: '';
            width: 4px;
            height: 16px;
            background: linear-gradient(135deg, #0084ff 0%, #0066cc 100%);
            border-radius: 2px;
        }
    }

    .button-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 10px;

        /deep/ .el-button + .el-button {
            margin-left: 0;
        }
        
        .dialog-btn {
            margin-bottom: 0;
        }
    }

    .dialog-btn {
        width: 100%;
        margin-bottom: 10px;
        height: 44px;
        font-size: 14px;
        font-weight: 500;
        border-radius: 8px;
        text-align: left;
        padding-left: 16px;
        display: flex;
        align-items: center;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        position: relative;
        overflow: hidden;
        
        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
            transition: left 0.5s;
        }
        
        &:hover::before {
            left: 100%;
        }

        &:last-child {
            margin-bottom: 0;
        }

        &:hover {
            transform: translateX(6px) scale(1.02);
            box-shadow: 0 6px 16px rgba(0, 132, 255, 0.3);
        }
        
        &:active {
            transform: translateX(6px) scale(0.98);
        }
        
        /deep/ i {
            font-size: 16px;
            margin-right: 8px;
            flex-shrink: 0;
        }
        
        /deep/ span {
            flex: 1;
            text-align: left;
        }
    }

    .extend-input-wrapper {
        margin-top: 10px;
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 12px;
        background: #f8f9fa;
        border-radius: 8px;
        border: 1px dashed #d0d7de;
        
        .input-label {
            font-size: 14px;
            color: #606266;
            font-weight: 500;
            white-space: nowrap;
        }
        
        .unit-text {
            font-size: 14px;
            color: #606266;
            white-space: nowrap;
        }

        .days-input {
            flex: 1;
            
            /deep/ .el-input-number__decrease,
            /deep/ .el-input-number__increase {
                background: #f0f0f0;
                border-color: #dcdfe6;
                color: #606266;
                
                &:hover {
                    color: #0084ff;
                    background: #e8f4ff;
                }
            }
        }

        .extend-btn {
            min-width: 110px;
            height: 40px;
            font-weight: 500;
            border-radius: 8px;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            
            &:hover {
                transform: translateX(4px) scale(1.05);
                box-shadow: 0 6px 16px rgba(0, 132, 255, 0.35);
            }
            
            &:active {
                transform: translateX(4px) scale(0.98);
            }
        }
    }
}

/deep/ .el-switch {
    &.is-checked .el-switch__core {
        background: linear-gradient(135deg, #0084ff 0%, #0066cc 100%);
        border-color: #0084ff;
    }
}

.save-section {
    margin-top: 30px;
    padding-top: 24px;
    border-top: 2px solid #e9ecef;
    display: flex;
    justify-content: center;
    gap: 16px;
}

.save-btn {
    min-width: 120px;
    height: 40px;
    font-size: 15px;
    font-weight: 500;
    border-radius: 8px;
    background: linear-gradient(135deg, #0084ff 0%, #0066cc 100%);
    border: none;
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(0, 132, 255, 0.4);
    }

    &:active {
        transform: translateY(0);
    }
}

.reset-btn {
    min-width: 120px;
    height: 40px;
    font-size: 15px;
    font-weight: 500;
    border-radius: 8px;
    border: 1px solid #dcdfe6;
    color: #606266;
    background: #ffffff;
    transition: all 0.3s ease;

    &:hover {
        color: #0084ff;
        border-color: #0084ff;
        background: #f0f7ff;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 132, 255, 0.15);
    }

    &:active {
        transform: translateY(0);
    }
}

// 响应式设计
@media (max-width: 768px) {
    .system-info-container {
        padding: 10px;
    }

    .system-card {
        /deep/ .el-card__body {
            padding: 20px 15px;
        }
    }

    .form-section {
        padding: 15px;
    }

    .save-section {
        flex-direction: column;
        
        .save-btn,
        .reset-btn {
            width: 100%;
        }
    }
}

// 动画效果
@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.system-card {
    animation: fadeInUp 0.5s ease-out;
}

.form-section {
    animation: fadeInUp 0.5s ease-out;
    animation-fill-mode: both;

    &:nth-child(1) {
        animation-delay: 0.1s;
    }

    &:nth-child(2) {
        animation-delay: 0.2s;
    }
}
</style>
